export default "__VITE_ASSET__3xepkAN8__"